/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SimCard(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M213.65723,82.34277l-56-56A8.00235,8.00235,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88A8.00235,8.00235,0,0,0,213.65723,82.34277ZM200,216H55.99219V40h92.69433L200,91.314l.00977,124.68555Z" />
      <Path d="M176,112H80a8.00039,8.00039,0,0,0-8,8v72a8.00039,8.00039,0,0,0,8,8h96a8.00039,8.00039,0,0,0,8-8V120A8.00039,8.00039,0,0,0,176,112Zm-56,64a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Z" />
    </Svg>
  );
}

export default SimCard;
